import { jsx as a } from "react/jsx-runtime";
import { c as m } from "./index-SYE1cn5_.js";
import * as c from "react";
import { T as i } from "./Text-D6i4LEWL.js";
const g = c.forwardRef(function({ children: r, variant: e = "accent", className: t, ...o }, s) {
  return /* @__PURE__ */ a(
    i,
    {
      className: m("badge", `badge--${e}`, t),
      variant: "caption-medium",
      asChild: !0,
      children: /* @__PURE__ */ a("span", { ref: s, ...o, children: r })
    }
  );
});
export {
  g as B
};
